<template>
  <div>
    <schedule-calendar
        :profile="profile"
    />
  </div>
</template>

<script>
import ScheduleCalendar from "./scheduleCalendar";

export default {
  name: "HeartBeat_Calendar",
  props: {
    heartbeat: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ScheduleCalendar
  },
  data() {
    return {
      view: "calendar" // list | calendar
    };
  }
};
</script>

<style lang="scss" scoped>
.schedule-btns {
  column-gap: 12px;
  margin-bottom: 24px;
  .schedule-btn {
    height: 35px;
    border: 1px solid #f3f6f9;
    background: #f3f6f9;
    border-radius: 8px;
    padding: 0px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    transition: all 0.2s ease-in-out;

    &:hover,
    &.active {
      border: 1px solid #557efb;
      background: #557efb;
      color: #ffffff;
    }
  }
}
</style>
